import apolloClient from '../apolloClient';
import { GET_CUSTOMER_DETAILS } from './queries/customerDetails';

/**
 * Fetch customer details (profile + company info)
 * Note: Backend uses [UseSingleOrDefault] so returns single object, not array
 */
export const fetchCustomerDetailsGraphQL = async () => {
  try {
    const { data } = await apolloClient.query({
      query: GET_CUSTOMER_DETAILS,
      fetchPolicy: 'network-only' // Always fetch fresh user data
    });

    // Returns single CustomerLogin object directly (not in nodes array)
    return data?.customerDetails || null;
  } catch (error) {
    console.error('Error fetching customer details:', error);
    throw error;
  }
};

